module.exports = __webpack_public_path__ + "static/media/instrukcje_produktów_420x240px.68e15201.png";